<klt-section title="Occupancy levels">
  <div class="graph-box">
    <klt-graph
      [loading]="titles.length == 0"
      height="388px"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
